import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ReactNode, useMemo } from 'react';

import GlobalStyles from './GlobalStyles';
import { CompanyTheme } from './theme/types';
import { createCompanyTheme } from './utils/createCompanyTheme';

type Props = {
    children: ReactNode;
    companyTheme?: CompanyTheme;
};

const ThemeProvider: React.FC<Props> = ({ children, companyTheme }) => {
    const theme = useMemo(() => {
        return createCompanyTheme(companyTheme);
    }, [companyTheme]);

    return (
        <EmotionThemeProvider
            theme={(initialTheme) => {
                return {
                    ...initialTheme,
                    ...theme,
                };
            }}
        >
            <GlobalStyles />
            {children}
        </EmotionThemeProvider>
    );
};

export default ThemeProvider;
